import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

@Directive({
  selector: '[wmFrontBodyScroll]',
  standalone: true,
})
export class BodyScrollDirective implements OnChanges {
  /** Whether or not the body scroll is lock */
  @Input() public isBodyLock: boolean

  /** Html element where we want only authorize the scroll */
  @Input() public target?: HTMLElement | Element

  private _el = inject(ElementRef)

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['isBodyLock']) {
      if (changes['isBodyLock'].currentValue) {
        const target = this.target ? this.target : this._el.nativeElement
        disableBodyScroll(target)
      } else {
        clearAllBodyScrollLocks()
      }
    }
  }
}
